/**
 * Base extendation for the Row-View - Form-Builder
 */
import {STYLE_INJECTION_MIXIN} from "../mixins/style-injection-mixin";
import ControlView from "../views/renderer/ControlView";

const RENDERER_ROW_VIEW_MIXIN = {
    components: {
        ControlView
    },
    mixins: [STYLE_INJECTION_MIXIN],

    props: {
        /**
         * Section that belong to the current row
         */
        section: {
            type: Object,
            required: true
        },

        /**
         * Current row data
         */
        row: {
            type: Object,
            required: true
        },

        /**
         * Controls of Form
         */
        controls: {
            type: Object,
            required: true,
        },

        valueContainer: Object,
        validationErrors: Object,
        readOnly: Boolean,
        visibleMap: Object,
        language: {
            type: String,
            default: 'en'
        }
    },

    computed: {

        /**
         * Check if we had controls
         * @returns {boolean}
         */
        hasControls() {
            return this.row.controls.length > 0
        },

        /**
         * Classes for draggable
         * @returns {(string|string)[]}
         */
        containerClasses() {
            return [
                this.styles.ROW,
                'control-list-container',
                (
                    this.hasControls
                        ? ''
                        : 'empty'
                )
            ]
        },
        filteredControls() {
            const controls = this.controls || {}
            const visibleMap = this.visibleMap || {}
            return (this.row.controls || []).filter(controlId => {
                const control = controls[controlId]
                if (!control) return false
                const key = control.name ? control.name : control.uniqueId
                if (!key) return true
                if (!Object.prototype.hasOwnProperty.call(visibleMap, key)) return true
                return !!visibleMap[key]
            })
        }
    },
}
export {
    RENDERER_ROW_VIEW_MIXIN
}